import React from 'react';

type BooleanIsh = boolean | string | number | object | null | undefined;

const RenderIf = ({ condition, children }: React.PropsWithChildren<{ condition: BooleanIsh }>) => {
  return <>{!!condition && children}</>;
};

export default RenderIf;
